const styles = {
  bubble: {
    position: "absolute",
    top: "0",
    left: "0",
    transform: "translate(-50%, -100%)",
    height: "24px",
    borderRadius: "4px",
    paddingTop: "2px",
    paddingLeft: "4px",
    paddingRight: "8px",
    backgroundColor: "#085FE5",
    fontFamily: "CircularStd",
    color: "#FFFFFF",
    boxShadow: "0 2px 4px 0 rgba(0,0,0,0.2)",
    overflowY: "auto",
    fontSize: "12px",
    fontWeight: "500",
    maxHeight: "60px",
  },
  anchor: {
    position: "absolute",
    width: "100%",
    bottom: "40px",
    left: "0",
  },
  container: {
    cursor: "auto",
    height: "0",
    position: "absolute",
    width: "200px",
  },
  svgIcon: {
    marginRight: "4px",
    display: "inline-block",
    verticalAlign: "middle",
  },
};

export default styles;
